import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-291aea0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "members-lists",
  class: "p-3"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-0" }, "Members list", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Online Members", -1))
const _hoisted_4 = { class: "members-list" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Offline Members", -1))
const _hoisted_6 = { class: "members-list" }

import { useMembersStore } from '@/stores/MembersStore';
import GuildMember from './GuildMember.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GuildMembersList',
  setup(__props) {

const membersStore = useMembersStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(membersStore).onlineMembers, (member) => {
        return (_openBlock(), _createBlock(GuildMember, {
          key: member.id,
          member: member
        }, null, 8, ["member"]))
      }), 128))
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(membersStore).offlineMembers, (member) => {
        return (_openBlock(), _createBlock(GuildMember, {
          key: member.id,
          member: member
        }, null, 8, ["member"]))
      }), 128))
    ])
  ]))
}
}

})